import {trackPromotionInteraction} from '@aboutyou/legacy-tracking-sdk';
import {
  Promotion,
  RecoListTrackingData,
} from '../trackerComponents/TrackPromotions';
import {getPromotionData} from '../utils/promotionDataGetter';
import {useTracking} from '../utils/utils';
import {useWaitUntilContentView} from '../utils/waitUntilContentView';

interface TrackPromotionInterface {
  promotion: Promotion;
  recoList?: RecoListTrackingData;
  streamPosition: number;
  actionType: 'click' | 'impression';
}

export const useTrackPromotion = () => {
  const {pageContextCallback, TrackingClient} = useTracking();
  const waitUntilContentView = useWaitUntilContentView();

  return ({
    promotion,
    recoList,
    streamPosition,
    actionType,
  }: TrackPromotionInterface) => {
    const pageContext = pageContextCallback();
    const promotionData = getPromotionData({
      promotion,
      streamPosition,
      recoList,
      pageType: pageContext.type,
    });

    const promotionInteractionData = trackPromotionInteraction({
      ...promotionData,
      type: actionType,
    });

    if (actionType === 'impression') {
      /**
       * Promotion tracking should only be fired after the contentView event of
       * this page is fired to ensure that dataLayer has correct page type and page id
       */
      waitUntilContentView(pageContext, () => {
        TrackingClient.track(promotionInteractionData);
      });
    } else {
      TrackingClient.track(promotionInteractionData);
    }
  };
};
